import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createBlock(_component_a_breadcrumb, { style: {"margin":"16px 0","padding-left":"24px"} }, {
    separator: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbdata, (item, i) => {
        return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
          key: 'breadcrumb' + i
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}